export const PUSH_TO_TIMELINE_POINTS = 'PUSH_TO_TIMELINE_POINTS';
export const SET_ACTIVE_TIMELINE_POINT = 'SET_ACTIVE_TIMELINE_POINT';
export const DELETE_TIMELINE_POINT = 'DELETE_TIMELINE_POINT';
export const SET_TIMELINE_POINTS = 'SET_TIMELINE_POINTS';
